import React from "react";
import {
  useState,
  useEffect,
  useContext,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Button, Form } from "react-bootstrap";
import Profile from "../../assets/Images/technician.png";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../BookingForm/components/Calender/Calender.css";
import "../../assets/css/Booking.css";
import moment from "moment";
import { getstafflist } from "../../Api/frontbooingApi";
import { getstaffTime } from "../../Api/frontbooingApi";
import { BookingContext } from "./BookingContext";
import { TbListCheck } from "react-icons/tb";
import {
  getstaffslotdatabyzone,
  getbuffertimedynamic,
} from "../../Api/frontbooingApi";
import { BUFFER_TIME_STAFF } from "../../Api/config";
import { SITE_URL } from "../../Api/config";
import { BsQuestionCircle } from "react-icons/bs";
import { companyData } from "../../../Api/settingApi";
import { formatImageByGender } from "../../../helper/formatImageByGender";
import Male from "../../../assets/images/Male.png";
import Female from "../../../assets/images/Female.png";
import { FaStar } from "react-icons/fa";

const Step2 = (props) => {
  const {
    currentStep,
    handleChange,
    email,
    order_Id,
    validationError = "",
    clearValidationError = () => {},
    setSlotsAvailable = () => {},
  } = props;
  const [
    usertype,
    setUsertype,
    chooseservice,
    setChooseservice,
    choosesubservice,
    setChoosesubservice,
    chooseaddon,
    setChooseaddon,
    choosetechnician,
    setChoosetechnician,
    choosedate,
    setChoosedate,
    choosetime,
    setChoosetime,
    userDetails,
    setUserDetails,
    paymentDetails,
    setPaymentDetails,
    Totalpayment,
    setTotalpayment,
    totalDuration,
    setTotalDuration,
    appointmentNotes,
    setAppointmentNotes,
    servicename,
    setServicename,
    endchoosetime,
    setEndchoosetime,
    confirmpassword,
    setConfirmpassword,
    signUprequest,
    setSignUprequest,
    technicianList,
    setTechnicianList,
    expectedprice,
    setExpectedprice,
    expectedduration,
    setExpectedduration,
    availableTimestatus,
    setAvailableTimestatus,
    resetChoosetechnician,
    zipcode,
    setZipcode,
    bookingdata,
    setBookingData,
    Newservicepercentage,
    setNewServicepercentage,
    oldtotalprice,
    setOldtotalPrice,
    promodata,
    setPromodata,
    amountwithdiscount,
    setAmountwithdiscount,
    specialClientRequests,
    setSpecialClientRequests,
    bookingTime,
    setBookingTime,
    clientNotes,
    setClientNotes,
    selectedShift,
    setSelectedShift,
  ] = useContext(BookingContext);

  const [stafflist, setStaffList] = useState([]);
  const [staffid, setStaffid] = useState(0);
  const [value, onChange] = useState();
  const [availableTimeloader, setAvailableTimeloader] = useState(false);
  const [availableTime, setavailableTime] = useState([]);
  const [selectedSlotid, setSelectedSlotid] = useState(null);
  const [techniciansWithSlots, setTechniciansWithSlots] = useState([]);
  const [checkingTechnicians, setCheckingTechnicians] = useState(false);
  const [checkedTechnicians, setCheckedTechnicians] = useState([]);
  const [showNoSlotsBanner, setShowNoSlotsBanner] = useState(false);

  const [availableTimerandom, setavailableTimeRandom] = useState([]);
  const [randomloader, setrandomLoader] = useState(false);
  const [randomtech, setRandomtech] = useState(true);
  const [showavailable, setShowavailable] = useState(false);
  const [servertime, setServerTime] = useState(null);
  const [bufferTimedync, SetBufferTimedync] = useState(0);
  const [companyInfo, setCompanyInfo] = useState({});
  const [hasCats, setHasCats] = useState(false);
  const [hasDogs, setHasDogs] = useState(false);

  // Validate booking time is within the selected shift range
  const validateBookingTime = (time, shift) => {
    if (!time) return true; // Allow empty for now, required attribute will handle it
    
    const [hours, minutes] = time.split(':').map(Number);
    const totalMinutes = hours * 60 + minutes;
    
    if (shift === "morning") {
      // Morning: 8:00 AM (480 minutes) to 12:00 PM (720 minutes)
      const minMinutes = 8 * 60; // 8:00 AM
      const maxMinutes = 12 * 60; // 12:00 PM
      return totalMinutes >= minMinutes && totalMinutes <= maxMinutes;
    } else {
      // Afternoon: 12:00 PM (720 minutes) to 5:00 PM (1020 minutes)
      const minMinutes = 12 * 60; // 12:00 PM
      const maxMinutes = 17 * 60; // 5:00 PM
      return totalMinutes >= minMinutes && totalMinutes <= maxMinutes;
    }
  };


  const getstaff = () => {
    getstafflist().then((res) => {
      if (res.code === 200) {
        const apiResponse = res.data;
        setStaffList(apiResponse.data);
      } else {
        alert("Something went wrong");
      }
    });
  };

  const getcompanyInfo = () => {
    companyData()
      .then((res) => {
        if (res.code === 200) {
          const apiResponse = res.data;
          setCompanyInfo(apiResponse.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getstaff();
    getbuffertimefunc();
    getcompanyInfo();
  }, []);

  // Auto-select current date when component mounts
  useEffect(() => {
    if (!value && props.currentStep === 2) {
      const today = new Date();
      onChange(today);
    }
  }, [props.currentStep]);

  const selectstaff = (id) => {
    setStaffid(id);
    setChoosetechnician(id);
  };

  useEffect(() => {
    getstaffavailability(value);
  }, [staffid]);

  // Auto-select first technician when "Choose Your Technician" is selected
  useEffect(() => {
    if (!randomtech && technicianList && technicianList.length > 0) {
      const firstTechnician = technicianList[0];
      // Only auto-select if no technician is currently selected or if the selected one is not in the list
      if (firstTechnician && firstTechnician.id && (staffid === 0 || !technicianList.find(t => t.id === staffid))) {
        setStaffid(firstTechnician.id);
        setChoosetechnician(firstTechnician.id);
      }
    }
  }, [randomtech, technicianList, staffid]);

  const getstaffavailability = (e, techId = null) => {
    const techToCheck = techId || staffid;
    setAvailableTimeloader(true);
    const date = moment(e).format("YYYY-MM-DD");
    setChoosedate(date);
    if (typeof clearValidationError === "function") {
      clearValidationError(); // Clear error when date changes
    }
    getstaffTime(date, techToCheck).then((res) => {
      if (res.code === 200) {
        const apiResponse = res.data;
        if (apiResponse.data.length > 0) {
          getavailableTimeSlots(apiResponse.data, date, techToCheck);
          setServerTime(apiResponse.server_time.date);
        } else {
          getavailableTimeSlots([], date, techToCheck);
        }
      } else {
        alert("Something went wrong");
        setAvailableTimeloader(false);
      }
    });
  };

  // Check all technicians for the selected date and shift
  const checkAllTechnicians = async (date) => {
    if (!technicianList || technicianList.length === 0 || !selectedShift) {
      return;
    }

    setCheckingTechnicians(true);
    setTechniciansWithSlots([]);
    setCheckedTechnicians([]);
    const dateStr = moment(date).format("YYYY-MM-DD");
    const techniciansWithAvailableSlots = [];
    let serverTimeForCheck = null;

    // Check each technician sequentially
    for (let i = 0; i < technicianList.length; i++) {
      const tech = technicianList[i];
      if (!tech || !tech.id) continue;

      try {
        const res = await getstaffTime(dateStr, tech.id);
        if (res.code === 200) {
          const apiResponse = res.data;
          const bookingData = apiResponse.data || [];
          
          // Get server time from first response
          if (!serverTimeForCheck && apiResponse.server_time) {
            serverTimeForCheck = apiResponse.server_time.date;
          }

          // Process slots similar to getavailableTimeSlots - check actual availability
          const serverMoment = serverTimeForCheck ? moment(serverTimeForCheck, "YYYY-MM-DD HH:mm:ss.SSSSSS") : moment();
          const bufferTime = bufferTimedync || 0;
          const occupiedSlots = bookingData.map((booking) => ({
            start: moment(booking.start).subtract(bufferTime, "minutes"),
            end: moment(booking.end).add(bufferTime, "minutes"),
          }));

          const startTime = moment(`${dateStr} 06:00:00`);
          const endTime = moment(`${dateStr} 19:00:00`);
          let current = startTime.clone();
          const availableSlots = [];

          while (
            current.clone().add(expectedduration, "minutes").isSameOrBefore(endTime)
          ) {
            const slotStart = current.clone();
            const slotEnd = slotStart.clone().add(expectedduration, "minutes");

            // Skip past times
            if (slotStart.isSameOrBefore(serverMoment)) {
              current.add(1, "hour");
              continue;
            }

            // Check overlap with buffer-adjusted slots
            const isOverlapping = occupiedSlots.some(({ start, end }) => {
              return slotStart.isBefore(end) && slotEnd.isAfter(start);
            });

            if (!isOverlapping) {
              availableSlots.push({
                start: slotStart.format("YYYY-MM-DD HH:mm:ss"),
                end: slotEnd.format("YYYY-MM-DD HH:mm:ss"),
              });
            }

            current.add(1, "hour");
          }
          
          // Check if this technician has slots for the selected shift
          const hasSlotsForShift = availableSlots.some((slot) => {
            const slotStart = moment(slot.start);
            const hour = slotStart.hour();
            if (selectedShift === "morning") {
              return hour >= 6 && hour < 12;
            } else if (selectedShift === "afternoon") {
              return hour >= 12 && hour < 19;
            }
            return true;
          });

          if (hasSlotsForShift) {
            techniciansWithAvailableSlots.push(tech.id);
          }
        }
      } catch (error) {
        console.log("Error checking technician:", tech.id, error);
      }

      // Mark this technician as checked
      setCheckedTechnicians(prev => [...prev, tech.id]);
    }

    // Update the list of technicians with slots
    setTechniciansWithSlots(techniciansWithAvailableSlots);
    setCheckingTechnicians(false);

    // Auto-select first available technician if any
    if (techniciansWithAvailableSlots.length > 0) {
      const firstAvailable = techniciansWithAvailableSlots[0];
      setStaffid(firstAvailable);
      setChoosetechnician(firstAvailable);
      // Load slots for the selected technician
      getstaffavailability(date, firstAvailable);
    } else {
      // No technicians available, clear selection
      setStaffid(0);
      setChoosetechnician(0);
      setavailableTime([]);
    }
  };

  const getbuffertimefunc = (e) => {
    getbuffertimedynamic().then((res) => {
      if (res.code === 200) {
        const apiResponse = res.data;
        const breakTimeInterval = apiResponse.data.break_time_interval;

        // Convert break time interval to minutes based on the value
        let breakTimeInMinutes;
        switch (breakTimeInterval) {
          case "1":
            breakTimeInMinutes = 0; // 0 Minutes
            break;
          case "2":
            breakTimeInMinutes = 15; // 15 Minutes
            break;
          case "3":
            breakTimeInMinutes = 30; // 30 Minutes
            break;
          case "4":
            breakTimeInMinutes = 45; // 45 Minutes
            break;
          case "5":
            breakTimeInMinutes = 60; // 1 Hour
            break;
          default:
            breakTimeInMinutes = 0;
        }

        SetBufferTimedync(breakTimeInMinutes);
      } else {
        SetBufferTimedync(0);
        alert("Something went wrong");
      }
    });
  };

  /*  NEW CODE FOR RANDOM TECHNICIAN  */

  /* AVALIABLE BOOKING SLOTE */
  /* AVALIABLE BOOKING SLOTE */
  function unionTimeSlots(data, startdate) {
    const slots = {};
    let unionSchedule = [];
    const startTime = moment(
      moment(startdate).set({ hour: 6, minute: 0, second: 0 })
    );
    const endTime = moment(
      moment(startdate).set({ hour: 19, minute: 0, second: 0 })
    );

    data.forEach((item) => {
      if (!slots[item.resourceId]) {
        slots[item.resourceId] = [];
      }

      if (
        item.className.trim() === "in_active_class" ||
        item.className.trim() === "off_day_class"
      ) {
        slots[item.resourceId].push({
          start: moment(item.start),
          end: moment(item.end),
        });
      }
    });

    const availableSlots = [];

    for (const resourceId in slots) {
      let current = moment(startTime);
      availableSlots[resourceId] = [];

      while (current.isBefore(endTime)) {
        let nextSlot = moment(current).add(1, "hour"); // Assuming 1-hour slots

        let isAvailable = true;
        slots[resourceId].forEach((bookedSlot) => {
          if (
            current.isBetween(bookedSlot.start, bookedSlot.end, null, "[)") ||
            nextSlot.isBetween(bookedSlot.start, bookedSlot.end, null, "[)")
          ) {
            isAvailable = false;
          }
        });

        if (isAvailable) {
          availableSlots[resourceId].push({
            start: current.format("YYYY-MM-DD HH:mm:ss"),
            end: nextSlot.format("YYYY-MM-DD HH:mm:ss"),
          });
        }

        current = nextSlot;
      }
    }

    for (let staffId in availableSlots) {
      if (availableSlots[staffId].length === 0) {
        delete availableSlots[staffId];
      } else {
        availableSlots[staffId].forEach((slot) => {
          unionSchedule.push({ staffId: staffId, ...slot });
        });
      }
    }

    // setAvailableTime(unionSchedule);
    // const aIds = new Set(technicianList.map(item => item.id));
    const aIds = new Set(
      technicianList.filter((item) => item != null).map((item) => item.id)
    );

    const filteredB = unionSchedule.filter((item) => aIds.has(item.staffId));

    console.log("Filtered B:", filteredB);

    generateMissingSlots(filteredB);
  }

  /* AVALIABLE BOOKING SLOTE */
  /* AVALIABLE BOOKING SLOTE */

  function generateMissingSlots(slots) {
    // setrandomLoader(true);
    let staffSlots = {};
    let generatedSlots = [];

    let uniqueSlots = [];
    let seenSlots = new Set();
    var counting = 1;

    // Organize slots by staff ID
    slots.forEach((slot) => {
      if (!staffSlots[slot.staffId]) {
        staffSlots[slot.staffId] = new Set();
      }
      staffSlots[slot.staffId].add(slot.start);
    });

    let allTimeSlots = new Set(slots.map((slot) => slot.start));

    // Generate missing slots for each staff
    Object.keys(staffSlots).forEach((staffId) => {
      allTimeSlots.forEach((timeSlot) => {
        if (staffSlots[staffId].has(timeSlot)) {
          // Generate the missing slot for this staff
          let newSlot = {
            id: counting++,
            staffId: staffId,
            start: timeSlot,
            end: moment(timeSlot)
              .add(bufferTimedync, "minute")
              .format("YYYY-MM-DD HH:mm:ss"),
          };
          if (moment(timeSlot).valueOf() >= moment(servertime).valueOf()) {
            generatedSlots.push(newSlot);
          }
          // generatedSlots.push(newSlot);
        }
      });
    });

    // Sort generated slots by start time
    generatedSlots.sort((a, b) => {
      let startTimeA = new Date(a.start);
      let startTimeB = new Date(b.start);
      return startTimeA - startTimeB;
    });

    generatedSlots.forEach((slot) => {
      let slotKey = slot.start + "|" + slot.end;
      if (!seenSlots.has(slotKey)) {
        seenSlots.add(slotKey);
        uniqueSlots.push(slot);
      }
    });

    // return uniqueSlots;
    setrandomLoader(false);
    setavailableTimeRandom(uniqueSlots);
  }

  // function getRandomAvailableSlotPerStaff(bookings, date, servertime) {
  //     setrandomLoader(true);

  //     const allStaff = new Set();

  //     // Get unique staff IDs
  //     bookings.forEach(b => {
  //         const ids = Array.isArray(b.resourceId) ? b.resourceId : [b.resourceId];
  //         ids.forEach(id => allStaff.add(id));
  //     });

  //     const startTime = moment(`${date} 06:00:00`);
  //     const endTime = moment(`${date} 19:00:00`);
  //     let current = startTime.clone();
  //     let counting = 1;

  //     const result = [];
  //     const availableSlots = [];

  //     [...allStaff].forEach(staffId => {
  //         const staffBookings = bookings.filter(b =>
  //             (Array.isArray(b.resourceId) && b.resourceId.includes(staffId)) ||
  //             b.resourceId === staffId
  //         );

  //         // console.log("staffBookings", staffBookings);

  //         const serverMoment = moment(servertime, "YYYY-MM-DD HH:mm:ss.SSSSSS");
  //         const bufferTime = bufferTimedync || 0; // default to 0 if not provided

  //         // Step 1: Adjust occupied slots with buffer time
  //         const occupiedSlots = staffBookings.map(booking => ({
  //             start: moment(booking.start).subtract(bufferTime, 'minutes'),
  //             end: moment(booking.end).add(bufferTime, 'minutes'),
  //         }));

  //         while (current.clone().add(expectedduration, 'minutes').isSameOrBefore(endTime)) {
  //             const slotStart = current.clone();
  //             const slotEnd = slotStart.clone().add(expectedduration, 'minutes');

  //             // Step 2: Skip past times
  //             if (slotStart.isSameOrBefore(serverMoment)) {
  //                 current.add(1, 'hour');
  //                 continue;
  //             }

  //             // Step 3: Check overlap with buffer-adjusted slots
  //             const isOverlapping = occupiedSlots.some(({ start, end }) => {
  //                 return slotStart.isBefore(end) && slotEnd.isAfter(start);
  //             });

  //             if (!isOverlapping) {
  //                 availableSlots.push({
  //                     id: counting++,
  //                     start: slotStart.format("YYYY-MM-DD HH:mm:ss"),
  //                     end: slotEnd.format("YYYY-MM-DD HH:mm:ss"),
  //                 });
  //             }

  //             current.add(1, 'hour');
  //         }
  //     });

  //     // Filter only technicians in technicianList
  //     const filteredResult = result.filter(item => {
  //         return technicianList.some(tech => tech.id === item.staffId);
  //     });

  //     setrandomLoader(false);
  //     setavailableTimeRandom(filteredResult);
  // }

  // function getRandomAvailableSlotPerStaff(bookings, date, servertime) {
  //     setrandomLoader(true);

  //     const allStaff = new Set();

  //     // Extract unique staff IDs
  //     bookings.forEach(b => {
  //         const ids = Array.isArray(b.resourceId) ? b.resourceId : [b.resourceId];
  //         ids.forEach(id => allStaff.add(id));
  //     });

  //     const startTime = moment(`${date} 06:00:00`);
  //     const endTime = moment(`${date} 19:00:00`);
  //     const serverMoment = moment(servertime, "YYYY-MM-DD HH:mm:ss.SSSSSS");
  //     const bufferTime = bufferTimedync || 0; // minutes
  //     const result = [];

  //     [...allStaff].forEach(staffId => {
  //         let current = startTime.clone();
  //         let slotId = 1;

  //         // Filter bookings for the current staff
  //         const staffBookings = bookings.filter(b =>
  //             (Array.isArray(b.resourceId) && b.resourceId.includes(staffId)) ||
  //             b.resourceId === staffId
  //         );

  //         // Build occupied slots with buffer
  //         const occupiedSlots = staffBookings.map(booking => ({
  //             start: moment(booking.start).subtract(bufferTime, 'minutes'),
  //             end: moment(booking.end).add(bufferTime, 'minutes'),
  //         }));

  //         while (current.clone().add(expectedduration, 'minutes').isSameOrBefore(endTime)) {
  //             const slotStart = current.clone();
  //             const slotEnd = slotStart.clone().add(expectedduration, 'minutes');

  //             // Skip if slot is in the past compared to server time
  //             if (slotStart.isSameOrBefore(serverMoment)) {
  //                 current.add(1, 'hour');
  //                 continue;
  //             }

  //             // Check if the slot overlaps any booking
  //             const isOverlapping = occupiedSlots.some(({ start, end }) =>
  //                 slotStart.isBefore(end) && slotEnd.isAfter(start)
  //             );

  //             if (!isOverlapping) {
  //                 result.push({
  //                     id: slotId++,
  //                     staffId: staffId,
  //                     start: slotStart.format("YYYY-MM-DD HH:mm:ss"),
  //                     end: slotEnd.format("YYYY-MM-DD HH:mm:ss"),
  //                 });
  //             }

  //             current.add(1, 'hour');
  //         }
  //     });

  //     // Filter only required technicianList (if technicianList is available)
  //     const filteredResult = technicianList?.length
  //         ? result.filter(item => technicianList.some(tech => tech.id === item.staffId))
  //         : result;

  //     setrandomLoader(false);
  //     setavailableTimeRandom(filteredResult);
  // }

  function getRandomAvailableSlotPerStaff(bookings, date, servertime) {
    setrandomLoader(true);

    // const allStaff = new Set();
    // bookings.forEach(b => {
    //     const ids = Array.isArray(b.resourceId) ? b.resourceId : [b.resourceId];
    //     ids.forEach(id => allStaff.add(id));
    // });

    const startTime = moment(`${date} 06:00:00`);
    const endTime = moment(`${date} 19:00:00`);
    const serverMoment = moment(servertime, "YYYY-MM-DD HH:mm:ss.SSSSSS");
    const bufferTime = bufferTimedync || 0;
    const availableSlots = [];
    let counting = 1;

    technicianList &&
      technicianList.forEach((staffId) => {
        let current = startTime.clone();
        const staffBookings = bookings.filter(
          (b) =>
            (Array.isArray(b.resourceId) &&
              b.resourceId.includes(staffId.id)) ||
            b.resourceId === staffId.id
        );

        const occupiedSlots = staffBookings.map((b) => ({
          start: moment(b.start).subtract(bufferTime, "minutes"),
          end: moment(b.end).add(bufferTime, "minutes"),
        }));

        while (
          current
            .clone()
            .add(expectedduration, "minutes")
            .isSameOrBefore(endTime)
        ) {
          const slotStart = current.clone();
          const slotEnd = slotStart.clone().add(expectedduration, "minutes");
          const slotKey = slotStart.format("HH:mm");

          // 1. Skip past times
          if (slotStart.isSameOrBefore(serverMoment)) {
            current.add(1, "hour");
            continue;
          }

          // 2. Check if overlapping with existing booking
          const isOverlapping = occupiedSlots.some(
            ({ start, end }) =>
              slotStart.isBefore(end) && slotEnd.isAfter(start)
          );

          // 3. If not overlapping & not already used globally
          if (!isOverlapping) {
            availableSlots.push({
              id: counting++,
              staffId: staffId.id,
              start: slotStart.format("YYYY-MM-DD HH:mm:ss"),
              end: slotEnd.format("YYYY-MM-DD HH:mm:ss"),
            });
          }

          current.add(1, "hour");
        }
      });
    // Optional: filter by technician list
    const filteredResult = technicianList?.length
      ? availableSlots.filter((item) =>
          technicianList.some((tech) => tech.id === item.staffId)
        )
      : availableSlots;
    // ✅ Sort slots by time (morning to evening)
    const sortedResult = filteredResult.sort((a, b) => {
      const timeA = moment(a.start, "YYYY-MM-DD HH:mm:ss");
      const timeB = moment(b.start, "YYYY-MM-DD HH:mm:ss");
      return timeA - timeB;
    });

    const mergedSlots = mergeByStartTime(sortedResult);
    setrandomLoader(false);
    setavailableTimeRandom(mergedSlots);
  }

  const mergeByStartTime = (data) => {
    // Group by start time
    const grouped = data.reduce((acc, curr) => {
      if (!acc[curr.start]) {
        acc[curr.start] = [];
      }
      acc[curr.start].push(curr);
      return acc;
    }, {});

    // Merge the grouped data
    let result = [];
    for (const start in grouped) {
      const slots = grouped[start];
      if (slots.length === 1) {
        result.push(slots[0]);
      } else {
        // Choose the first entry for each start time and merge the other data
        const mergedSlot = {
          id: slots[0].id, // Retaining the first id (you can modify this logic if needed)
          staffId: slots[0].staffId, // Keeping the first staffId for the merged slot
          start: slots[0].start,
          end: slots[slots.length - 1].end, // Taking the last 'end' time
        };
        result.push(mergedSlot);
      }
    }

    return result;
  };

  const fetchAndProcessSlots = (date, zipcode) => {
    setrandomLoader(true);
    if (typeof clearValidationError === "function") {
      clearValidationError(); // Clear error when date changes
    }
    getstaffslotdatabyzone(date, zipcode).then((res) => {
      if (res.code === 200) {
        if (res.data.status === 1) {
          const apiResponse = res.data;
          if (apiResponse.data.length > 0) {
            getRandomAvailableSlotPerStaff(apiResponse.data, date);
            setServerTime(apiResponse.server_time.date);
            setShowavailable(true);
          } else {
            getRandomAvailableSlotPerStaff([], date);
            setShowavailable(true);
          }
        }
      } else {
        alert("Something went wrong");
      }
    });
  };

  useEffect(() => {
    if (value != undefined) {
      const date = moment(value).format("YYYY-MM-DD");
      setChoosedate(date);
      fetchAndProcessSlots(date, zipcode);
    }
  }, [randomtech, value]);

  // useEffect(() => {
  //     const date = moment(value).format("YYYY-MM-DD");
  //     fetchAndProcessSlots(date, zipcode);
  // }, [chooseservice]);

  useEffect(() => {
    // Ensure technicianList is an array before calling filter
    if (Array.isArray(technicianList) && chooseservice) {
      const filteredStaff = technicianList.filter((person) =>
        person.service_ids?.split(",").includes(chooseservice)
      );
      setTechnicianList(filteredStaff);
    }
  }, [chooseservice]);

  // Track slot availability and notify parent
  useEffect(() => {
    if (randomtech && showavailable) {
      setSlotsAvailable(availableTimerandom.length > 0);
    } else if (!randomtech && availableTime) {
      setSlotsAvailable(availableTime.length > 0);
    }
  }, [availableTimerandom, availableTime, randomtech, showavailable]);

  // Clear time slot selection when date changes
  useEffect(() => {
    setChoosetime("");
    setSelectedSlotid(null);
  }, [choosedate]);


  /* AVALIABLE BOOKING SLOTE */
  /* AVALIABLE BOOKING SLOTE */

  // const getavailableTimeSlots = (bookingData, startdate) => {
  //     const serverMoment = moment(servertime, "YYYY-MM-DD HH:mm:ss.SSSSSS");

  //     const occupiedSlots = bookingData.map(booking => ({
  //         start: moment(booking.start),
  //         end: moment(booking.end),
  //     }));

  //     const startTime = moment(`${startdate} 06:00:00`);
  //     const endTime = moment(`${startdate} 19:00:00`);

  //     const availableSlots = [];
  //     let current = startTime.clone();
  //     let counting = 1;

  //     while (current.clone().add(expectedduration, 'minutes').isSameOrBefore(endTime)) {
  //         const slotStart = current.clone();
  //         const slotEnd = slotStart.clone().add(expectedduration, 'minutes');

  //         if (slotStart.isSameOrBefore(serverMoment)) {
  //             current.add(1, 'hour');
  //             continue;
  //         }

  //         const isOverlapping = occupiedSlots.some(({ start, end }) => {
  //             return slotStart.isBefore(end) && slotEnd.isAfter(start);
  //         });

  //         if (!isOverlapping) {
  //             availableSlots.push({
  //                 id: counting++,
  //                 start: slotStart.format("YYYY-MM-DD HH:mm:ss"),
  //                 end: slotEnd.format("YYYY-MM-DD HH:mm:ss"),
  //             });
  //         }

  //         current.add(1, 'hour');
  //     }
  //     setAvailableTimeloader(false);
  //     setavailableTime(availableSlots);
  // };

  const getavailableTimeSlots = (bookingData, startdate, techId = null) => {
    const serverMoment = moment(servertime, "YYYY-MM-DD HH:mm:ss.SSSSSS");
    const bufferTime = bufferTimedync || 0; // default to 0 if not provided

    // Step 1: Adjust occupied slots with buffer time
    const occupiedSlots = bookingData.map((booking) => ({
      start: moment(booking.start).subtract(bufferTime, "minutes"),
      end: moment(booking.end).add(bufferTime, "minutes"),
    }));

    const startTime = moment(`${startdate} 06:00:00`);
    const endTime = moment(`${startdate} 19:00:00`);

    const availableSlots = [];
    let current = startTime.clone();
    let counting = 1;

    while (
      current.clone().add(expectedduration, "minutes").isSameOrBefore(endTime)
    ) {
      const slotStart = current.clone();
      const slotEnd = slotStart.clone().add(expectedduration, "minutes");

      // Step 2: Skip past times
      if (slotStart.isSameOrBefore(serverMoment)) {
        current.add(1, "hour");
        continue;
      }

      // Step 3: Check overlap with buffer-adjusted slots
      const isOverlapping = occupiedSlots.some(({ start, end }) => {
        return slotStart.isBefore(end) && slotEnd.isAfter(start);
      });

      if (!isOverlapping) {
        availableSlots.push({
          id: counting++,
          start: slotStart.format("YYYY-MM-DD HH:mm:ss"),
          end: slotEnd.format("YYYY-MM-DD HH:mm:ss"),
        });
      }

      current.add(1, "hour");
    }

    setAvailableTimeloader(false);
    setavailableTime(availableSlots);
    console.log("amineshverma bookingData", bookingData);
    console.log("amineshverma startdate", startdate);
    console.log("amineshverma servertime", servertime);
    console.log("amineshverma expectedduration", expectedduration);
  };

  /* AVALIABLE BOOKING SLOTE */
  /* AVALIABLE BOOKING SLOTE */

  // Helpers to know if morning / afternoon have any slots for current day
  const hasMorningRandomSlots = availableTimerandom.some((item) => {
    const hour = moment(item.start).hour();
    return hour >= 6 && hour < 12;
  });

  const hasAfternoonRandomSlots = availableTimerandom.some((item) => {
    const hour = moment(item.start).hour();
    return hour >= 12 && hour < 19;
  });

  const hasSelectedShiftRandomSlots =
    selectedShift === "morning" ? hasMorningRandomSlots : hasAfternoonRandomSlots;

  const hasMorningStaffSlots = availableTime.some((item) => {
    const hour = moment(item.start).hour();
    return hour >= 6 && hour < 12;
  });

  const hasAfternoonStaffSlots = availableTime.some((item) => {
    const hour = moment(item.start).hour();
    return hour >= 12 && hour < 19;
  });

  const hasSelectedShiftStaffSlots =
    selectedShift === "morning" ? hasMorningStaffSlots : hasAfternoonStaffSlots;

  const noSlotsForSelectedTechnician =
    !randomtech &&
    value &&
    choosetechnician !== 0 &&
    selectedShift && 
    !availableTimeloader &&
    !hasSelectedShiftStaffSlots;
  
  useEffect(() => {
    let combined = `Booking Time : ${bookingTime || ""}\nInstructions : ${clientNotes || ""}`;
    
    if (noSlotsForSelectedTechnician && choosetechnician !== 0 && technicianList) {
      const selectedTech = technicianList.find(tech => tech.id === choosetechnician);
      if (selectedTech && selectedTech.fullname) {
        combined = `${combined}\nRequested Technician : ${selectedTech.fullname}`;
      }
    }
    
    setSpecialClientRequests(combined);
  }, [bookingTime, clientNotes, selectedShift, noSlotsForSelectedTechnician, choosetechnician, technicianList, setSpecialClientRequests]);

  useEffect(() => {
    let timer;
    if (noSlotsForSelectedTechnician) {
      setShowNoSlotsBanner(false);
      timer = setTimeout(() => {
        setShowNoSlotsBanner(true);
      }, 1000); // 1 second delay
    } else {
      setShowNoSlotsBanner(false);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [noSlotsForSelectedTechnician]);

  // Display all technicians without filtering
  const getAvailableTechnicians = () => {
    let list = technicianList || [];

    if (hasCats) {
      list = list.filter(
        (tech) => tech && tech.fullname && !tech.fullname.includes("Breanne")
      );
    }

    return list;
  };

  const availableTechnicians = getAvailableTechnicians();

  useEffect(() => {
    if (!availableTechnicians.length) return;

    const selectedStillValid = availableTechnicians.some(
      tech => tech.id === staffid
    );

    if (!selectedStillValid) {
      const firstTechnician = availableTechnicians[0];
      setStaffid(firstTechnician.id);
      setChoosetechnician(firstTechnician.id);
    }
  }, [hasCats, technicianList]);

  if (props.currentStep !== 2) {
    return null;
  }

  return (
    <>
      <div className="booking-form-box">
        <div className="row">
          <div className="col-md-12">
            <div className="step-count">
              <div className="step-count-inner">
                <div className="Step-icon">
                  <span>
                    <TbListCheck />
                  </span>
                </div>
                <div className="step-count-inner-title">Technician</div>
                <div className="question-tooltip-wrapper ms-1">
                  <BsQuestionCircle className="question-icon technician-question-icon" />
                  <div className="tooltip-popup technician-tooltip">
                    <div className="tooltip-content">
                      <div>
                        {companyInfo && companyInfo?.technician_summary}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showNoSlotsBanner && (
            <div className="col-md-12">
              <div className="no-slots-banner">
                <h3>We&apos;ve Got You Covered</h3>
                <p>
                  We&apos;ll try to book your preferred technician and time.
                </p>
                <p>
                  If unavailable, we&apos;ll recommend and assign the best
                  alternative so your service stays on track.
                </p>
              </div>
            </div>
          )}

          <div className="col-md-12">
            <div
              className="technician-list"
              style={{ display: randomtech ? "none" : "block" }}
            >
              {availableTechnicians &&
                availableTechnicians.map((item, index) => (
                  <Button
                    key={item.id || index}
                    className={`technician-profile-btn ${
                      staffid === item.id ? "active" : ""
                    }`}
                    onClick={() => selectstaff(item.id)}
                  >
                    <div className="technician-profile">
                      <div className="technician-profile-img">
                        {/* {item.image ? (
                                                <img src={`${SITE_URL}uploads/photo/${item.image}`} alt="Avatar" />
                                            ) : (
                                                <img src={Profile} alt="Avatar" />
                                            )} */}
                        <img
                          src={formatImageByGender(
                            item.gender,
                            item.image,
                            "createTechnician"
                          )}
                          alt="Avatar"
                          onError={(e) => {
                            // Prevent infinite loop - check if fallback already set
                            if (!e.target.dataset.fallbackSet) {
                              e.target.dataset.fallbackSet = "true";
                              if (item.gender === "female") {
                                e.target.src = Female;
                              } else {
                                e.target.src = Male;
                              }
                            } else {
                              // If fallback also fails, prevent further error handling
                              e.target.onerror = null;
                            }
                          }}
                        />
                      </div>
                      <div className="technician-profile-info">
                        <div className="technician-profile-name">
                          <h4>{item.fullname}</h4>
                        </div>
                      </div>
                    </div>
                  </Button>
                ))}
            </div>
            <div className="technician-list">
              <Form>
                <div className="mb-3">
                  <Form.Check
                    type="checkbox"
                    id="random-tech"
                    checked={randomtech}
                    onChange={(e) => setRandomtech(e.target.checked)}
                    label="Select Random Technician"
                  />
                </div>
                <div className="mb-3">
                  <Form.Check
                    type="checkbox"
                    id="choose-tech"
                    checked={!randomtech}
                    onChange={(e) => setRandomtech(!e.target.checked)}
                    label="Choose Your Technician"
                  />
                </div>
              </Form>
            </div>
          </div>
        </div>
        <div
          className="row booking-warrper-40"
          {...(choosetechnician === 0
            ? { style: { display: "none" } }
            : { style: { display: "block" } })}
        >
          <div
            className="col-md-12"
            {...(choosetechnician === 0
              ? { style: { display: "none" } }
              : { style: { display: "block" } })}
          >
            <div className="step-count">
              <div className="step-count-inner">
                <div className="Step-icon">
                  <span>
                    <TbListCheck />
                  </span>
                </div>
                <div className="step-count-inner-title">
                  When would you like us to come?
                </div>
                <div className="question-tooltip-wrapper ms-1">
                  <BsQuestionCircle className="question-icon calendar-question-icon" />
                  <div className="tooltip-popup calendar-tooltip">
                    <div className="tooltip-content">
                      <div>{companyInfo && companyInfo?.calender_summary}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Morning / Afternoon tabs */}
            <div
              className="time-list mt-3"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                gap: "0.75rem",
              }}
            >
              <Button
                className={`time-btn mb-0 h-auto w-100 ${
                  selectedShift === "morning" ? "active" : ""
                }`}
                onClick={() => {
                  setSelectedShift("morning");
                  setSelectedSlotid(null);
                  setChoosetime("");
                  setBookingTime(""); // Clear booking time when shift changes
                  if (typeof clearValidationError === "function") {
                    clearValidationError();
                  }
                }}
              >
                <div className="time-btn-inner">
                  <div className="time-btn-inner-title d-flex flex-column">
                    <div className="time-btn-inner-title-text">Morning</div>
                    <div className="time-btn-inner-title-text">
                      8:00 AM - 12:00 PM
                    </div>
                  </div>
                </div>
              </Button>
              <Button
                className={`time-btn mb-0 h-auto w-100 ${
                  selectedShift === "afternoon" ? "active" : ""
                }`}
                onClick={() => {
                  setSelectedShift("afternoon");
                  setSelectedSlotid(null);
                  setChoosetime("");
                  setBookingTime(""); // Clear booking time when shift changes
                  if (typeof clearValidationError === "function") {
                    clearValidationError();
                  }
                }}
              >
                <div className="time-btn-inner">
                  <div className="time-btn-inner-title d-flex flex-column">
                    <div className="time-btn-inner-title-text">Afternoon</div>
                    <div className="time-btn-inner-title-text">
                      12:00 PM - 5:00 PM
                    </div>
                  </div>
                </div>
              </Button>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6 col-lg-12 col-md-12">
              {bookingdata && bookingdata?.appointment_starttime && (
                <div className="calender-box">
                  <p style={{ border: "red 2px solid", borderRadius: "6px" }}>
                    {`Your start booking date and time is ${bookingdata?.appointment_starttime}`}
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6 col-lg-12 col-md-12">
              <div className="calender-box">
                <Calendar
                  minDate={new Date()}
                  onChange={(e) => {
                    onChange(e);
                    getstaffavailability(e);
                  }}
                  value={value}
                />
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 col-md-12">
              <div
                className="time-box p-0"
                style={{ width: "100%", background: "transparent" }}
              >
                <div className="time-box-inner" style={{ width: "100%" }}>
                  {randomtech ? (
                    <div className="time-list">
                      {showavailable ? (
                        <>
                            <div className="calendar-legend mt-0">
                              <div className="row Service-details-box-inner-title mb-0">
                                <div className="col-md-12">
                                    <Form.Label>
                                      Special Client Requests
                                </Form.Label>
                                <Form.Group className="booking-custom-lable mb-3">
                                  <Form.Label>
                                    Booking Time: <span style={{ color: "red" }}>*</span>
                                    </Form.Label>
                                    <Form.Control
                                    type="time"
                                    value={bookingTime}
                                      onChange={(e) => {
                                      const selectedTime = e.target.value;
                                      if (selectedTime && !validateBookingTime(selectedTime, selectedShift)) {
                                        // Time is out of range, don't update and show error
                                        if (selectedShift === "morning") {
                                          alert("Please select time between 8:00 AM - 12:00 PM");
                                        } else {
                                          alert("Please select time between 12:00 PM - 5:00 PM");
                                        }
                                        return;
                                      }
                                      setBookingTime(selectedTime);
                                        clearValidationError();
                                      }}
                                    min={selectedShift === "morning" ? "08:00" : "12:00"}
                                    max={selectedShift === "morning" ? "12:00" : "17:00"}
                                    step="900"
                                    required
                                      className="booking-custom-input p-2"
                                      style={{
                                        border: "1px solid #ccc",
                                      }}
                                    />
                                  <p
                                    style={{
                                      color: "#6c7581",
                                      fontSize: "12px",
                                      marginBottom: "8px",
                                      fontWeight: "500",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {selectedShift === "morning" 
                                      ? "Select time between 8:00 AM - 12:00 PM" 
                                      : "Select time between 12:00 PM - 5:00 PM"}
                                  </p>
                                </Form.Group>
                                <Form.Group className="booking-custom-lable mb-3">
                                  <Form.Label>Do you have pets?</Form.Label>
                                  <div>
                                    <Form.Check
                                      inline
                                      type="checkbox"
                                      id="pets-cats-random-available"
                                      label="Cats"
                                      style={{ color: "#6c7581", fontWeight: "500" }}
                                      checked={hasCats}
                                      onChange={(e) => {
                                        setHasCats(e.target.checked);
                                      }}
                                    />
                                    <Form.Check
                                      inline
                                      type="checkbox"
                                      id="pets-dogs-random-available"
                                      label="Dogs"
                                      style={{ color: "#6c7581", fontWeight: "500" }}
                                      checked={hasDogs}
                                      onChange={(e) =>
                                        setHasDogs(e.target.checked)
                                      }
                                    />
                                </div>
                                </Form.Group>
                                <Form.Group className="booking-custom-lable">
                                  <Form.Label>
                                    Special Instructions: <span style={{ color: "red" }}>*</span>
                                  </Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    value={clientNotes}
                                    onChange={(e) => {
                                      setClientNotes(e.target.value);
                                      clearValidationError();
                                    }}
                                    placeholder="Instructions for parking, access details and notes for the technician"
                                    required
                                    className="booking-custom-input p-2"
                                    style={{
                                      height: "150px",
                                      border: "1px solid #ccc",
                                    }}
                                  />
                                </Form.Group>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="calendar-legend mt-0">
                          <div className="row Service-details-box-inner-title mb-0">
                            <div className="col-md-12">
                                <Form.Label>
                                  Special Client Requests
                              </Form.Label>
                              <Form.Group className="booking-custom-lable mb-3">
                                <Form.Label>
                                  Booking Time: <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                  type="time"
                                  value={bookingTime}
                                  onChange={(e) => {
                                    const selectedTime = e.target.value;
                                    if (selectedTime && !validateBookingTime(selectedTime, selectedShift)) {
                                      // Time is out of range, don't update and show error
                                      if (selectedShift === "morning") {
                                        alert("Please select time between 8:00 AM - 12:00 PM");
                                      } else {
                                        alert("Please select time between 12:00 PM - 5:00 PM");
                                      }
                                      return;
                                    }
                                    setBookingTime(selectedTime);
                                    clearValidationError();
                                  }}
                                  min={selectedShift === "morning" ? "08:00" : "12:00"}
                                  max={selectedShift === "morning" ? "12:00" : "17:00"}
                                  step="900"
                                  required
                                  className="booking-custom-input p-2"
                                  style={{
                                    border: "1px solid #ccc",
                                  }}
                                />
                              <p
                                style={{
                                  color: "#6c7581",
                                  fontSize: "12px",
                                  marginBottom: "8px",
                                  fontWeight: "500",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                  {selectedShift === "morning" 
                                    ? "Select time between 8:00 AM - 12:00 PM" 
                                    : "Select time between 12:00 PM - 5:00 PM"}
                                </p>
                              </Form.Group>
                              <Form.Group className="booking-custom-lable mb-3">
                                <Form.Label>Do you have pets?</Form.Label>
                                <div>
                                  <Form.Check
                                    inline
                                    type="checkbox"
                                    id="pets-cats-random-unavailable"
                                    label="Cats"
                                    style={{ color: "#6c7581", fontWeight: "500" }}
                                    checked={hasCats}
                                    onChange={(e) => {
                                      setHasCats(e.target.checked); 
                                    }}
                                  />
                                  <Form.Check
                                    inline
                                    type="checkbox"
                                    id="pets-dogs-random-unavailable"
                                    label="Dogs"
                                    style={{ color: "#6c7581", fontWeight: "500" }}
                                    checked={hasDogs}
                                    onChange={(e) => setHasDogs(e.target.checked)}
                                  />
                                </div>
                              </Form.Group>
                              <Form.Group className="booking-custom-lable">
                                <Form.Label>
                                  Special Instructions: <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  value={clientNotes}
                                  onChange={(e) => {
                                    setClientNotes(e.target.value);
                                    clearValidationError();
                                  }}
                                  placeholder="Instructions for parking, access details and notes for the technician"
                                  required
                                  className="booking-custom-input p-2"
                                  style={{
                                    height: "150px",
                                    border: "1px solid #ccc",
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="time-list">
                      { (
                        <div className="calendar-legend mt-0">
                          <div className="row Service-details-box-inner-title mb-0">
                            <div className="col-md-12">
                              <Form.Label>
                                Special Client Requests
                              </Form.Label>
                              <Form.Group className="booking-custom-lable mb-3">
                                <Form.Label>Booking Time: <span style={{ color: "red" }}>*</span></Form.Label>
                                <Form.Control
                                  type="time"
                                  value={bookingTime}
                                  onChange={(e) => {
                                    const selectedTime = e.target.value;
                                    if (selectedTime && !validateBookingTime(selectedTime, selectedShift)) {
                                      // Time is out of range, don't update and show error
                                      if (selectedShift === "morning") {
                                        alert("Please select time between 8:00 AM - 12:00 PM");
                                      } else {
                                        alert("Please select time between 12:00 PM - 5:00 PM");
                                      }
                                      return;
                                    }
                                    setBookingTime(selectedTime);
                                    if (
                                      typeof clearValidationError === "function"
                                    ) {
                                      clearValidationError();
                                    }
                                  }}
                                  min={selectedShift === "morning" ? "08:00" : "12:00"}
                                  max={selectedShift === "morning" ? "12:00" : "17:00"}
                                  step="900"
                                  required
                                  className="booking-custom-input p-2"
                                  style={{
                                    border: "1px solid #ccc",
                                  }}
                                />
                                <p
                                  style={{
                                    color: "#6c7581",
                                    fontSize: "12px",
                                    marginBottom: "8px",
                                    fontWeight: "500",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {selectedShift === "morning" 
                                    ? "Select time between 8:00 AM - 12:00 PM" 
                                    : "Select time between 12:00 PM - 5:00 PM"}
                                </p>
                              </Form.Group>
                              <Form.Group className="booking-custom-lable mb-3">
                                <Form.Label>Do you have pets?</Form.Label>
                                <div>
                                  <Form.Check
                                    inline
                                    type="checkbox"
                                    id="pets-cats-choose-tech"
                                    label="Cats"
                                    style={{ color: "#6c7581", fontWeight: "500" }}
                                    checked={hasCats}
                                    onChange={(e) => {
                                      setHasCats(e.target.checked);
                                    }}
                                  />
                                  <Form.Check
                                    inline
                                    type="checkbox"
                                    id="pets-dogs-choose-tech"
                                    label="Dogs"
                                    style={{ color: "#6c7581", fontWeight: "500" }}
                                    checked={hasDogs}
                                    onChange={(e) => setHasDogs(e.target.checked)}
                                  />
                                </div>
                              </Form.Group>
                              <Form.Group className="booking-custom-lable">
                                <Form.Label>Special Instructions: <span style={{ color: "red" }}>*</span></Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  value={clientNotes}
                                  onChange={(e) => {
                                    setClientNotes(e.target.value);
                                    if (
                                      typeof clearValidationError === "function"
                                    ) {
                                      clearValidationError();
                                    }
                                  }}
                                  placeholder="Instructions for parking, access details and notes for the technician"
                                  required
                                  className="booking-custom-input p-2"
                                  style={{
                                    height: "150px",
                                    border: "1px solid #ccc",
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              {validationError && (
                <div
                  style={{
                    color: "red",
                    marginTop: "10px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {validationError}
                </div>
              )}
            </div>
          </div>
        </div>
        <style>
          {`.calendar-legend {
                        color: red;
                        font-size: 14px;
                        margin-top: 10px;
                        font-weight: bold;
                        }

                        .no-availability-mark {
                        margin-right: 5px;
                        }
                             
                        .question-tooltip-wrapper {
    position: relative;
    display: inline-block;
}

.question-icon {
    color: #6c757d;
    font-size: 16px;
    cursor: pointer;
    transition: color 0.2s ease;
}

.question-icon:hover {
    color: #75b317;
}

.tooltip-popup {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: -5px;
    left: 25px;
    background-color: #333;
    color: white;
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.tooltip-popup::before {
    content: "";
    position: absolute;
    top: 50%;
    left: -5px;
    margin-top: -5px;
    border-width: 5px 5px 5px 0;
    border-style: solid;
    border-color: transparent #333 transparent transparent;
}

.question-tooltip-wrapper:hover .tooltip-popup {
    visibility: visible;
    opacity: 1;
}

@media (max-width: 768px) {
    .tooltip-popup {
        left: -50px;
        top: 25px;
    }
    
    .tooltip-popup::before {
        top: -5px;
        left: 50px;
        margin-left: -5px;
        border-width: 0 5px 5px 5px;
        border-color: transparent transparent #333 transparent;
    }
}
    .tooltip-popup {
    min-width: 250px; /* Limit max width */
    max-width: 250px; /* Limit max width */
    font-size: 12px;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.no-slots-banner {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 12px 16px;
    margin-top: 20px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    text-align: center;
}

.no-slots-banner h3 {
    color: #75b317;
    font-size: 24px;
    margin: 0 0 4px;
    font-weight: 700;
}

.no-slots-banner p {
    margin: 0;
    line-height: normal;
    font-size: 16px;
    color: #4a4f55;
}
                                    .technician-question-icon {
                                        font-size: 20px;
                                        color: #6c757d;
                                    }

                                    .technician-tooltip {
                                        width: 250px;
                                        font-size: 12px;
                                    }`}
        </style>
      </div>
    </>
  );
};

export default Step2;
